import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { InputMask } from 'primeng/inputmask';
import { SelectItem } from 'primeng/api';

import { BaseComponent, AppSettingsService, Message } from 'iui-iconectiv-lib';

import {
  Account
} from '../account-completion';

import {
  AccountRegistration,
  AccountRegistrationBase,
} from './account-registration';

import {
  RegisterService
} from './register.service';
import {Regions} from "../shared/enum";
import {BaseRua} from "../shared/model";
import {RegionalUserAgreementService} from "../regional-user-agreement/rua.service";

const INVALID_INPUT = 'invalid-input'; // css class

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegisterComponent extends BaseComponent implements AfterViewInit, AfterViewChecked, OnInit {

  successfullySubmitted = false;

  // set page load focus on SPID field; needs AfterViewChecked, AfterViewInit, and ElementRef
  @ViewChild('spid') inputSpid: ElementRef;
  @ViewChild('spidMask') spidMask: InputMask; // needed for setFocus


  regions: { id: string, label: string }[] = Regions.regions;
  // xx = 'btn btn-default';
  accountRegistration: AccountRegistration;

  npacUserTypes: SelectItem[];
  otherServices: SelectItem[];
  recaptchaPublicKey: string;
  recaptchaStr = '';
  index: number;
  acknowledgementBox: boolean = false;
  
  // validator patterns:
  // name
  nameValidatorPattern = Account.nameValidatorPattern;

  // phone
  phoneValidatorPattern = Account.phoneValidatorPattern;

  // ZIP code
  zipCodeValidatorPattern = Account.zipCodeValidatorPattern;

  constructor(
    private registerService: RegisterService,
    private ruaService: RegionalUserAgreementService,
    private appSettings: AppSettingsService) {
    super();

    this.accountRegistration = new AccountRegistration();
    // this.log.debug(`this.accountRegistration.ruaList[0]=${JSON.stringify(this.accountRegistration.ruaList)}`);
    // this.log.debug(`ac 39: this.accountRegistration=${JSON.stringify(this.accountRegistration)}`);

    // npac user types dropdown options
    this.npacUserTypes = [
      { label: 'PTRS', value: 'PTRS' },
      { label: 'Service Bureau', value: 'Service Bureau' },
      { label: 'Service Provider', value: 'Service Provider' },
      { label: 'Other', value: 'Other' },
    ];

    // other iconectiv services dropdown options
    this.otherServices = [
      { label: 'Common Language', value: 'Common Language' },
      { label: 'Telecom Routing Administration (TRA)', value: 'Telecom Routing Administration (TRA)' },
      { label: 'TruNumber Gateway', value: 'TruNumber Gateway' },
      { label: 'TruNumber Protect', value: 'TruNumber Protect' },
      { label: 'TruNumber Routing', value: 'TruNumber Routing' },
      // { label: 'Right Party Verification (RPV)', value: 'Right Party Verification (RPV)' },
      { label: 'Other', value: 'Other' },
      { label: 'None', value: 'None' },
    ];

    this.appSettings.getSettings().subscribe(s => {
      this.recaptchaPublicKey = s['recaptchaPublicKey'];
     });

  }

  ngOnInit() {}

  // use AfterViewInit() set focus
  ngAfterViewInit() {
    //setTimeout(() => { this.inputSpid['inputViewChild'].nativeElement.focus(); }, 0);
  }

  // needed for focus to be activated
  ngAfterViewChecked() {}


  public resolved(captchaResponse: string) {
    this.recaptchaStr = captchaResponse;
    this.log.debug(`Resolved captcha with response ${captchaResponse}:`);
  }


  /**
   * when save is invoked means both the non-RUA and RUA sections are valid
   * @param isValid - angular Form validation results
   */
  save(isValid: boolean) {
    this.log.debug(`angular said the form validity: ${isValid}`);

    if (isValid === false) {
      this.displayErrorMessage(
        'Please fill out all required fields in the correct format.'
      );

      return;
    }

    this.saveRuaThenRegisterAccount();

  }


  saveRuaThenRegisterAccount() {
    this.clearMessages();
    if (!this.hasDigitsAndLetters(this.accountRegistration.spid, 4)) {
      this.displayErrorMessage(new Message('Error', 'The SPID must be 4 characters.'));
      return false;
    }
    this.registerAccount();
    // use contDownLatch to ensure all ids of RUA attachments are obtained prior to register the account
   /* let countDownLatch = this.accountRegistration.selectedRegions.length;
    if (countDownLatch === 0) {
      this.log.debug('calling registeraccount()');
      this.registerAccount();
      return;
    }
    this.index = 0;
    for (const rua of this.accountRegistration.ruaList) {
     
      if (this.accountRegistration.selectedRegions.indexOf(rua.region)> -1) {
      
       this.clearMessages();

      const fileSize = rua.ruaUserFileSize;
      const fileType = rua.ruaUserFileType;

      // const fileSuffix = this.ruaList[index].ruaUserFileName.split('.').pop();

      if (fileType !== 'application/pdf')
      {

       this.displayErrorMessage(new Message('Error', 'Regional User Agreement file type must be .pdf for the region ' + rua.region));
       window.scrollTo(0, 0);
       return false;
         
     }

      if (fileSize > 3000000)
           {

            this.displayErrorMessage(new Message('Error', 'Regional User Agreement file size for the region ' + rua.region + ' must be less than 3000 kilobytes.'));
            window.scrollTo(0, 0);
            return false;
              
          }

         
      this.index++;
     
      const json = `{"fileName" : "${rua.ruaParcelFileName}","contentType" : "application/pdf","content" : "${rua.attachmemtContent}"}`;

      this.ruaService.saveAccountRua(json).subscribe(
        res => {
          
            if (res['status'] === 'fail') {
              // prepare error message
              const message: any = res['messages'][0];
              const errorMessage = message['code'] + ' - ' + message['message'];
              this.displayErrorMessage(errorMessage);
              window.scrollTo(0, 0);
            } else {
              rua.attachmentId = res['attachmentId'];
              countDownLatch--;
              if (countDownLatch === 0) {
                this.log.debug('calling registeraccount()');
                this.registerAccount();
              }
            }
          },
          error => this.processHttpError(error)
        );
      } 
    }*/
  }


  registerAccount() {
    this.clearMessages();
    const json = this.prepareAccountData();
    this.registerService.registerAccount(json).subscribe(
      res => {
        this.log.debug(`data=${JSON.stringify(res).substr(0, 1000)}`);

        if (res['status'] === 'fail') {
          // prepare error message
          const message: any = res['messages'][0];
          const errorMessage = message['code'] + ' - ' + message['message'];
          this.displayErrorMessage(errorMessage);
          window.scrollTo(0, 0);
        } else {
          // successfully registered.
          this.displaySuccessMessage(
            'Success',
            'You have submitted the registration form for a iconectiv® TruNumber Finder Account. '
            + 'The Customer Support team will contact you shortly with more information to access the system.',
            60000
          );

          this.successfullySubmitted = true;
        }
      },
      error => this.processHttpError(error)
    );

  }


  prepareAccountData(): string {
    const ar = this.accountRegistration;
   /* const ruaBaseList: BaseRua[] = [];

    for (const rua of ar.ruaList) {
      if (ar.selectedRegions.indexOf(rua.region) < 0) {
        continue;
      }
      const ruaBase = new BaseRua();
      ruaBase.attachmentId = rua.attachmentId;
      ruaBase.contractNumber = rua.contractNumber;
      ruaBase.expirationDate = rua.expirationDate;
      ruaBase.region = rua.region;
      ruaBaseList.push(ruaBase);
    }*/

    const arBase = new AccountRegistrationBase();
    arBase.address1 = ar.address1;
    arBase.address2 = ar.address2;
    arBase.city = ar.city;
    arBase.companyName = ar.companyName;
    arBase.country = ar.country;
    arBase.email = ar.email;
    arBase.firstName = ar.firstName;
    arBase.lastName = ar.lastName;
    arBase.npacUserType = ar.npacUserType;
    arBase.otherServices = ar.otherServicesArray.join(',');
    arBase.phone = ar.phone;
    arBase.spid = ar.spid;
    arBase.state = ar.state;
    arBase.zipCode = ar.zipCode;
    //arBase['ruaList'] = ruaBaseList;
    arBase.recaptchaResponse = this.recaptchaStr;
    return JSON.stringify(arBase);
  }

  // dospid(event) {
  //   this.log.debug(event);
  // }


  btnStyleClass(nonRuaValid): string {
    if (this.isFormValid(nonRuaValid)) {
      return 'btn-default';
    } else {
      return 'btn-disabled';
    }
  }


  isFormValid(nonRuaValid: boolean): boolean {
    return (nonRuaValid && this.recaptchaStr !== '' && this.recaptchaStr != null) && this.acknowledgementBox;
  }


  hasDigitsAndLetters(string: string, n: number): boolean {

    if (string === null || string === '') {
      return true;
    } else { //non(alphanumeric + _ )
      return string.replace(/[\W_]/g, '').length === n;
    }
  }


  getScSpid(): string {
    let rv = '';
    if (!this.hasDigitsAndLetters(this.accountRegistration.spid, 4)) {
      rv = INVALID_INPUT;
    }

    return rv;
  }

}
